import React from "react";

const aryan_mehta = () => {
  return (
    <div>
      <h1>Aryan Mehta</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?
      </p>

      <ol>
        <li>Online Aptitude Test </li>
        <li>
          Offline interviews
          <ol>
            <li>Technical Round </li>
            <li>HR Round</li>
          </ol>
        </li>
      </ol>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?{" "}
      </p>

      <ul>
        <li>Superset applications began on 21st July, 2025. </li>
        <li>PPT and test were scheduled on 24th July (Online) </li>
        <li>
          Both interview rounds took place on 29th July. Results were declared
          on the same day
        </li>
      </ul>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        There were mainly 3 kinds of questions (90 minutes total)
      </p>

      <ol>
        <li>
          <strong>Coding Questions (2 Qs)</strong>:
          <ol>
            <li>Coding questions were of a moderate level </li>
            <li>Different questions for everyone. </li>
            <li>
              Most of the questions that were asked were based on greedy and
              graph patterns.{" "}
            </li>
          </ol>
        </li>
        <li>
          <strong>Technical MCQ questions (Around 20 Qs)</strong>
          <ol>
            <li>
              basic questions about core subjects like OS, DBMS and OOPS, but
              focused on DBMS/OOPS.{" "}
            </li>
            <li>Runtime Polymorphism(Overriding), SQL Syntax. </li>
          </ol>
        </li>
        <li>
          <strong>Oral (Speaking) Skills (2 Qs)</strong>
        </li>
      </ol>

      <p>
        This was an interesting one. You will be shown a prompt question and
        have 20 seconds to read it, after which you must speak your response
        into the microphone. Your response should be under one minute, after
        which the recording automatically stops. There is only one attempt for
        this question - no retries - so make sure you read and understand it
        thoroughly.
      </p>

      <p>
        The purpose of this question is to evaluate how well you can think on
        your feet and articulate your thoughts within a limited time. These were
        roughly the kind of questions that were asked.
      </p>

      <p>
        <strong>Q)</strong> Elaborate on a traumatic experience from your
        childhood and state the lesson you learned from it.
        <br />
        <strong>Q)</strong> How do you handle conflicts among team members while
        working on a large project?
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        25 students were selected from the Aptitude round.
        <br />
        Additionally, 3 candidates were kept as a backup
        <br />
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        Aptitude results were announced on July 24th, and the interviews began
        on July 28th, giving us roughly 4 days to prepare. During this time, I
        mainly focused on preparing projects mentioned in my resume and solving
        general DSA problems.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 interview rounds:
      </p>

      <p>
        <strong>Technical Interview</strong> (12-13 were shortlisted from this
        round)
        <br />
        The technical interview lasted for around 30 minutes. Students were
        asked about their projects, DSA and logic puzzles.{" "}
      </p>

      <p>
        In DSA, people were asked different questions ranging from linked
        lists(reversing a LL, finding midpoint), to array-based, to trees, as
        well as graphs.
      </p>

      <p>
        After reading my resume, the interviewer wrote a list of numbers on the
        paper and passed it to me. My task was to{" "}
        <strong>“find the maximum sum</strong>{" "}
        <strong>formed by a subarray”.</strong>
      </p>

      <p>
        The interviewer was more focused on my entire thought process than the
        end code. I quickly began to write down my logic. Take special care to
        keep thinking out loud and communicate your thoughts to the interviewer
        throughout. After I was done, we dry-ran the code through an example
        together and moved on once they were satisfied.
      </p>

      <p>
        After DSA, the focus shifted to my projects. I was questioned about my
        full-stack project – more specifically about the database I had used
        (MongoDB). I was asked why I prefer to use MongoDB instead of SQL -
        essentially making me explain the differences between relational and
        NoSQL databases.
      </p>

      <p>
        Next was a puzzle. The question was{" "}
        <strong>“Given two jugs of 5L and 3L, how do you measure 4L?”.</strong>{" "}
      </p>

      <p>
        After the puzzles, the interviewer seemed satisfied and finally asked me
        if I had any questions. We proceeded to have a discussion about system
        design in one of the company projects discussed in the PPT, after which
        the interview concluded.
      </p>

      <p>
        <strong>HR Interview</strong> (4 CS students were chosen for the offer)
        <br />
        My HR interview lasted for 40-50 minutes. I was asked about my hobbies,
        strengths and my views on certain topics. Some behaviour-based questions
        were also asked.
      </p>

      <p>
        While giving my introduction, I had mentioned that one of my hobbies is
        reading about any topic I find interesting, such as psychology. This
        piqued the interviewer’s interest, and I was asked to state some
        observations I made about people.
      </p>

      <p>
        The interviewer then explained the role and internship process. I was
        asked how I’d react if I were assigned to a project that didn’t match my
        interests. It was a behavioural question meant to see what the candidate
        expects from the internship.
      </p>

      <p>
        After this, I was evaluated on my speaking skills. The interviewer asked
        me to deliver a 20-second “<strong>TED Talk</strong>” on any topic of my
        choice. The focus was less on the content itself and more on how I
        structured my thoughts and articulated my points.
      </p>

      <p>
        I was also asked questions like <strong>Why COEP</strong> when I had
        qualified for other colleges as well, and{" "}
        <strong>why Computer Science</strong>.
      </p>

      <p>
        Finally, I was asked if I had any questions. We had a nice conversation
        about how the hiring process has evolved in recent years, after which
        the interview concluded.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        <strong>Technical Interview:</strong>
        <br />
        The interviewer was more interested in how I approached the problem
        rather than the final solution. It focused on DSA, Puzzles and Projects.
      </p>

      <p>
        <strong>HR Interview:</strong>
        <br />
        The interviewer was mostly looking for clarity of speech, thought, quick
        thinking and expressiveness.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ul>
        <li>LeetCode, GFG </li>
        <li>DSA - Striver’s A2Z sheet </li>
        <li>
          Core Courses
          <ul>
            <li>CN, OS - Love Babbar’s PDF notes </li>
          </ul>
        </li>
        <li>System Design: NeetCode IO’s videos</li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Don't just start coding straight away, try to{" "}
        <strong>run the problem through different cases</strong> first to
        understand how it works
      </p>

      <p>
        (For example: initially, I assumed that we should reset the sum whenever
        a negative number occurs – later, through a test case, I realised that
        it wasn't correct and quickly changed my course){" "}
      </p>

      <p>Make sure to clarify any questions about the problem. </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Questions mostly revolved around DSA, Projects and Hobbies.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Pay special attention to the PPT and familiarise yourself with the
        company projects. It was really helpful and led to a really fruitful
        discussion at the end of my technical interview.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <ol>
        <li>
          <strong>Resume and CV</strong>
          <ol>
            <li>
              Spend time making your CV as concise and to-the-point as possible{" "}
            </li>
            <li>
              Be extremely thorough with everything you have written in your
              resume - be prepared for cross-questioning{" "}
            </li>
          </ol>
        </li>
        <li>
          <strong>Projects</strong>
          <ol>
            <li>
              Study your projects, and make sure you can explain the{" "}
              <strong>idea</strong> behind the project clearly{" "}
            </li>
            <li>
              **<strong>IMPORTANT</strong>**: You should be CRYSTAL clear about
              the design decisions you have taken in your projects and why. This
              leaves a lasting impact on interviewers
              <br />
              (Example:
              <br />
              Why did i use a TST and not a Trie in my DSA project? What are the
              pros and cons of each? Why SQL instead of MongoDB?){" "}
            </li>
          </ol>
        </li>
        <li>
          <strong>Technical Interview</strong>
          <ol>
            <li>
              It's okay to take a few seconds before answering. Keep your
              replies calm and concise.{" "}
            </li>
            <li>
              If the DSA problem seems daunting
              at first – dont panic! It's alright! You won't always fully know
              the topics being asked. Just try to work your way towards a solution from scratch
              <br />
            </li>
          </ol>
        </li>
        <li>
          <strong>HR Interview:</strong>
          <ol>
            <li>
              Refrain from academics when talking about your hobbies and
              interests. Your analytical ability has already been tested in the
              Tech Round - the HR round is to evaluate you as a co-worker and a
              team member.
            </li>
          </ol>
        </li>
      </ol>
      <p>
      Lastly, its important to take care of yourself throughout this process. It can feel daunting at times, but have faith in your preparation and ability. Good things take time. It might take a while to get the result you want, but the effort you put will never go to waste. All the best! :) 
      </p>
      {/* <p>
        .<br />
        <strong>My Previous Mistakes</strong>
        <br />
        I’ve added this section because I believe there’s often more to learn
        from mistakes than from successes.
        <br />
        Before this, I was shortlisted for another company’s interview process…
        but didn't make it through the Technical round. After thinking about the
        interview, these are the areas I had narrowed down and focused on
        improving:
      </p>

      <ol>
        <li>
          <strong>My answers were too long:</strong>
          <br />
          When asked about my Projects(they didn't specify which), instead of
          giving a birds-eye view of all my projects, I decided to explain my
          favourite one in detail which ended up wasting time{" "}
        </li>
        <li>
          <strong>Not clarifying expectations</strong>
          <br />
        </li>
        <li>
          <strong>Resume:</strong>
          <br />I had foolishly added a topic in my resume in which I felt I had
          some experience. However, the questions I was asked about that topic
          were fairly advanced, and I was unable to answer
        </li>
      </ol> */}

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:amehta350@gmail.com">amehta350@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/aryan-mehta-858715276/">
          Aryan Mehta
        </a>
      </p>

      <hr />
    </div>
  );
};

export default aryan_mehta;
